import React from "react";
import LogIn from "./pages/log-in";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import DashbBoard from "./pages/app/dashboard";
import PrivateRoute from "./utils/PrivateRoute";
import Layout from "./components/layout";
import Error from "./components/Error";
import ScheduleInterview from "./pages/app/jd-resume/create";
import ScheduledInterviewList from "./pages/app/jd-resume/list";
import Interview from "./pages/app/interview";
import Home from "./pages/app/home";
import CreateJobDescription from "./pages/app/create-job-description";
import CreateRecruiter from "./pages/app/settings/create-recruiter";
import RecruiterList from "./pages/app/settings/recruiter-list";
import CreateRole from "./pages/app/settings/create-role";
import CreateCustomQuestion from "./pages/app/settings/create-custom-question";
import EditScheduleInterview from "./pages/app/jd-resume/edit";
import GlobalSearch from "./pages/app/global-talent-search";
import Authenticated from "./components/common-components/authenticate/Authenticated";
import ForgotPassword from "../src/pages/forgot-password/index";
import ResetPassword from "../src/pages/reset-password/index";
import EditUser from "./pages/app/settings/edit-user";
import CandidateReports from "./pages/app/jd-resume/reports/CandidateReports";
import InterviewWelcome from "./pages/app/interview/InterviewWelcome";
import TechnicalAssessmentTest from "./pages/app/technical-assessment/TechnicalAssessmentTest";
import Jobs from "./pages/app/jobs";
import CreateJob from "./pages/app/jobs/create";
import Selected from "./pages/app/selected";
import CandidateDetails from "./pages/app/selected/candidate-details";
import FinalShortlistedPage from "./pages/app/final-shortlisted";
const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <LogIn />,
    errorElement: <Error />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "/interview-welcome",
    element: <InterviewWelcome />,
  },
  {
    path: "/app",
    element: (
      <Authenticated>
        <Layout />
      </Authenticated>
    ),
    children: [
      {
        path: "intelligent-resume-matching",
        element: (
          <PrivateRoute
            element={<Home />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
      {
        path: "create-job-description",
        element: (
          <PrivateRoute
            element={<CreateJobDescription />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
      {
        path: "dashboard",
        element: (
          <PrivateRoute
            element={<DashbBoard />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "interview/schedule-interview",
        element: (
          <PrivateRoute
            element={<ScheduleInterview />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "interview/list-schedule-interview",
        element: (
          <PrivateRoute
            element={<ScheduledInterviewList />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "interview/edit-schedule-interview",
        element: (
          <PrivateRoute
            element={<EditScheduleInterview />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "interview/candidate-reports",
        element: (
          <PrivateRoute
            element={<CandidateReports />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "interview/final-shortlisted",
        element: (
          <PrivateRoute
            element={<FinalShortlistedPage />}
            requiredRoleType={["admin"]}
          />
        ),
      },
      {
        path: "global-talent-search",
        element: (
          <PrivateRoute
            element={<GlobalSearch />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
      {
        path: "settings/create-recruiter",
        element: (
          <PrivateRoute
            element={<CreateRecruiter />}
            requiredRoleType={["admin"]}
          />
        ),
      },
      {
        path: "settings/recruiter-list",
        element: (
          <PrivateRoute
            element={<RecruiterList />}
            requiredRoleType={["admin"]}
          />
        ),
      },
      {
        path: "settings/edit-recruiter/:id",
        element: (
          <PrivateRoute element={<EditUser />} requiredRoleType={["admin"]} />
        ),
      },
      {
        path: "settings/create-role",
        element: (
          <PrivateRoute element={<CreateRole />} requiredRoleType={["admin"]} />
        ),
      },
      {
        path: "settings/create-custom-question",
        element: (
          <PrivateRoute
            element={<CreateCustomQuestion />}
            requiredRoleType={["admin"]}
          />
        ),
      },
      {
        path: "jobs",
        element: (
          <PrivateRoute
            element={<Jobs />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "jobs/create",
        element: (
          <PrivateRoute
            element={<CreateJob />}
            requiredRoleType={["admin", "recruiter"]}
          />
        ),
      },
      {
        path: "selected",
        element: (
          <PrivateRoute
            element={<Selected />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
      {
        path: "selected/candidate/:id",
        element: (
          <PrivateRoute
            element={<CandidateDetails />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
      {
        path: "jobs/:id",
        element: (
          <PrivateRoute
            element={<CreateJob />}
            requiredRoleType={["admin", "recruiter", "hiring manager"]}
          />
        ),
      },
    ],
  },
  {
    path: "technical-assessment",
    element: <TechnicalAssessmentTest />,
  },
  {
    path: "interview",
    element: <Interview />,
  },
  {
    path: "interview-demo",
    element: <Interview />,
  },
]);

const Router = () => {
  return <RouterProvider router={appRouter} />;
};

export default Router;
